import service from "@/utils/request";
import Bold from "wangeditor/dist/menus/bold";

// 课时列表
export interface getLessonListData {
  page?: number;
  page_size?: number;
  sort_field?: string;
  sort_type?: string;
  start_date?: string;
  end_date?: string;
  class_id?: number;
  teacher_id?: number;
  student_id?: number;
  roll_call_status?: number;
  week_day?: number;
  start_time?: string;
  lesson_type?: number;
  course_id?: number;
  classroom_id?: number;
}
export const getLessonList = (params: getLessonListData) => {
  return service({
    url: "/api/v1/class/lesson/list",
    method: "get",
    params,
  });
};
// 课时详情
export interface getLessonDetailData {
  lesson_id: number;
}
export const getLessonDetail = (params: getLessonDetailData) => {
  return service({
    url: "/api/v1/class/lesson/detail",
    method: "get",
    params,
  });
};

// 点名异常学员列表
export const abnormalStudentListApi = (params: { roll_call_id: number }) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/abnormal_list",
    method: "get",
    params,
  });
};
// 课时学员列表
export interface getLessonStudentListData {
  lesson_id: number;
  page?: number;
  page_size?: number;
}
export const getLessonStudentList = (params: getLessonStudentListData) => {
  return service({
    url: "/api/v1/class/lesson/student/list",
    method: "get",
    params,
  });
};
// 课次学员删除
export interface deleteLessonStudentData {
  lesson_id: number;
  student_id: number;
}
export const deleteLessonStudent = (data: deleteLessonStudentData) => {
  return service({
    url: "/api/v1/class/lesson/student/del",
    method: "post",
    data,
  });
};
// 课次学员添加
export interface addLessonStudentData {
  lesson_id: number;
  student_type: number;
  in_roll_call?: boolean;
  student_list: {
    student_id: number;
    course_id: number;
  }[];
}
export const addLessonStudent = (data: addLessonStudentData) => {
  return service({
    url: "/api/v1/class/lesson/student/add",
    method: "post",
    data,
  });
};
// 编辑课次
export interface editLessonData {
  lesson_id: number;
  class_id: number;
  course_id: number;
  teacher_ids: number[];
  main_teacher_id: number;
  lesson_type: number;
  start_time: string;
  end_time: string;
  dates: string[];
}
export const editLesson = (data: editLessonData) => {
  return service({
    url: "/api/v1/class/lesson/edit",
    method: "post",
    data,
  });
};
// 编辑时间
export interface editLessonTimeData {
  lesson_id: number;
  start_time: string;
  end_time: string;
  date: string;
}
export const editLessonTime = (data: editLessonTimeData) => {
  return service({
    url: "/api/v1/class/lesson/edit_time",
    method: "post",
    data,
  });
};
// 删除课次
export interface deleteLessonData {
  lesson_ids: number[];
  class_id: number;
  reason?: string;
}
export const deleteLesson = (data: deleteLessonData) => {
  return service({
    url: "/api/v1/class/lesson/del",
    method: "post",
    data,
  });
};

// 批量修改上课时间
export interface mutiEditTimeData {
  lesson_ids: number[];
  class_id: number;
  start_time: string;
  end_time: string;
}
export const mutiEditTimeApi = (data: mutiEditTimeData) => {
  return service({
    url: "/api/v1/class/lesson/batch_edit_time",
    method: "post",
    data,
  });
};
// 批量修改上课课程
export interface mutiEditCourseData {
  lesson_ids: number[];
  class_id: number;
  course_id: number;
}
export const mutiEditCourseApi = (data: mutiEditCourseData) => {
  return service({
    url: "/api/v1/class/lesson/batch_edit_course",
    method: "post",
    data,
  });
};
// 批量修改教师和授课类型
export interface mutiEditTeacherData {
  lesson_ids: number[];
  class_id: number;
  teacher_ids: number[];
  main_teacher_id: number;
  lesson_type: number;
}
export const mutiEditTeacherApi = (data: mutiEditTeacherData) => {
  return service({
    url: "/api/v1/class/lesson/batch_edit_teacher",
    method: "post",
    data,
  });
};
// 批量修改教室
export interface mutiEditClassRoomData {
  class_id: number;
  lesson_ids: number[];
  classroom_id: number;
}
export const mutiEditClassRoom = (data: mutiEditClassRoomData) => {
  return service({
    url: "/api/v1/class/lesson/batch_edit_classroom",
    method: "post",
    data,
  });
};
// 给学员批量分配课程顾问
export interface DistributeFollowStaffData {
  student_ids: number[];
  follow_staff_id?: number;
  join_potential?: boolean;
}
export const DistributeFollowStaffApi = (data: DistributeFollowStaffData) => {
  return service({
    url: "/api/v1/student/distribute/follow_staff",
    method: "post",
    data,
  });
};
// 给学员批量分配教务
export interface DistributeFollowTeacherData {
  student_ids: number[];
  teacher_id: number;
}
export const DistributeTeacherApi = (data: DistributeFollowTeacherData) => {
  return service({
    url: "/api/v1/student/distribute/teacher",
    method: "post",
    data,
  });
};
// 课次学员统计
export interface lessonStudentCountData {
  lesson_id: number;
}
export const lessonStudentCountApi = (params: lessonStudentCountData) => {
  return service({
    url: "/api/v1/class/lesson/student/count",
    method: "get",
    params,
  });
};
//未点名课次列表
export interface noRollCallListApiData {
  page: number;
  page_size: number;
  sort_field?: string;
  sort_type?: string;
  start_date?: string;
  end_date?: string;
  class_id?: number;
  course_id?: number;
  teacher_id?: number;
  course_type?: number;
  lesson_type?: number;
  subject_ids?: [];
}
export const noRollCallListApi = (data: noRollCallListApiData) => {
  return service({
    url: "/api/v1/class/lesson/no_roll_call_list",
    method: "post",
    data,
  });
};

// 未点名课次数量
export interface lessonNotRollCallCountInter {
  lesson_date: string;
  lesson_type?: number;
}
export const getLessonNotRollCallCountApi = (
  params: lessonNotRollCallCountInter
) => {
  return service({
    url: "/api/v1/class/lesson/not_roll_call/count",
    method: "get",
    params,
  });
};

// 未点名课次删除
export const lessonNotRollCallDelApi = (data: lessonNotRollCallCountInter) => {
  return service({
    url: "/api/v1/class/lesson/not_roll_call/del",
    method: "post",
    data,
  });
};

// 已排课日期列表
export const arrangedDateListApi = (params: {
  class_id: number;
  start_date: string;
  end_date: string;
}) => {
  return service({
    url: "/api/v1/class/lesson/exist_date_list",
    method: "get",
    params,
  });
};

// 按天调课(课次数量)
export const lessonMoveByDataCountApi = (params: { date: string }) => {
  return service({
    url: "/api/v1/class/lesson/move_by_data_count",
    method: "get",
    params,
  });
};
// 按天调课
export const lessonMoveByDataApi = (data: {
  date: string;
  new_date: string;
}) => {
  return service({
    url: "/api/v1/class/lesson/move_by_data",
    method: "post",
    data,
  });
};
